import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const alienvaultOtx = defineConnector({
  identifier: "alienvaultOtx",
  name: "AlienVault OTX",
  tagLine: "Open threat intelligence",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://otx\\.alienvault\\.com/api/.*",
  auth: (app) =>
    headerAuth([{ name: "X-OTX-API-KEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [AlienVault OTX](https://otx.alienvault.com/) and sign up for an account. Navigate to your profile settings to find your API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "AlienVault OTX API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://otx.alienvault.com/api/v1/user/me",
  },
});
